__webpack_require__.p = "/Algo-Atlas/";